import {Injectable} from '@angular/core';
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
})
export class TranslateMessageService extends MessageService {
    constructor(private translate: TranslateService) {
        super();
    }

    override add(message: any) {
        if (message.summary) {
            message.summary = this.translate.instant(message.summary);
        }
        if (message.detail) {
            message.detail = this.translate.instant(message.detail);
        }

        super.add(message);
    }
}
